import "core-js/modules/es7.object.get-own-property-descriptors.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/web.dom.iterable.js";
import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.function.name.js";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/es6.promise.js";
import "core-js/modules/es6.object.assign.js";
import "core-js/modules/es7.promise.finally.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapActions, mapGetters } from 'vuex';
import '~/node_modules/@web/shared-digital-library/icons/svg-originals/panier.svg';

var AddToCartModal = function AddToCartModal() {
  return import(
  /* webpackMode: "eager" */
  '~/components/molecules/Product/Modal/AddToCartModal.vue');
};

export default {
  name: 'TheCartSection',
  components: {
    AddToCartModal: AddToCartModal
  },
  props: {
    product: {
      type: Object,
      required: true
    },
    isCrossProductExist: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      showModal: false,
      btnDisabled: false
    };
  },
  computed: _objectSpread(_objectSpread({}, mapGetters({
    locale: 'i18n/locale'
  })), {}, {
    cartTracking: function cartTracking() {
      return {
        fn: 'add-to-cart',
        data: {
          product_id: this.product.reference,
          product_name: this.product.name,
          product_category: "".concat(window.tc_vars.page_cat1, "/").concat(window.tc_vars.page_cat2, "/").concat(window.tc_vars.page_cat3, "/").concat(window.tc_vars.page_cat4, "/").concat(window.tc_vars.page_cat5),
          product_brand: window.tc_vars.product_brand,
          product_variant: window.tc_vars.product_variant || '',
          product_totalprice_ati: window.tc_vars.product_totalprice_ati,
          product_quantity: 1,
          product_activity: window.tc_vars.product_activity,
          page_product: 'FicheProduit',
          product_style: window.tc_vars.product_style,
          product_room: window.tc_vars.product_room
        }
      };
    }
  }),
  methods: _objectSpread(_objectSpread({}, mapActions({
    addCart: 'cart/add'
  })), {}, {
    addToCart: function addToCart(qty, event) {
      var _this = this;

      this.trackAddToCart(event);
      this.btnDisabled = true;
      this.addCart({
        reference: this.product.reference,
        referenceEncoded: btoa(this.product.reference),
        offer: this.product.offer ? this.product.offer.reference : null,
        quantity: qty
      }).then(function () {
        _this.showModal = true;
      }).catch(function (err) {
        _this.$logger.error(err);
      }).finally(function () {
        _this.btnDisabled = false;
      });
    },
    trackAddToCart: function trackAddToCart(event) {
      this.$root.$emit('generic-tracking', event, this.cartTracking);

      if (this.$cookies.get('algolia')) {
        try {
          var payload = JSON.parse(localStorage.getItem('algoliaLastEvent'));

          if (payload.objectIDs[0] === this.product.reference) {
            window.aa('convertedObjectIDsAfterSearch', _objectSpread(_objectSpread({}, payload), {}, {
              eventName: 'add_cart_product_page'
            }));
          }

          localStorage.removeItem('algoliaLastEvent');
        } catch (err) {
          this.$logger.error(err);
        }
      }
    },
    closeAction: function closeAction() {
      this.showModal = false;
    },
    handleAddToCartCta: function handleAddToCartCta(event) {
      this.addToCart(1, event);
    }
  })
};